export default {
    name: 'ContextTime',
    properties: {
        epoch: {},
    },
};
